export default __webpack_public_path__ + "static/media/defaultuser.d6ef2cf9.png";